import { OS } from "enum/common";
import { useState, useEffect } from "react";

export function useMobileOS() {
  const [os, setOS] = useState("Other");

  useEffect(() => {
    // @ts-ignore
    const ua = navigator.userAgent || navigator.vendor || window?.opera;

    if (/android/i.test(ua)) {
      setOS(OS.ANDROID);
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      setOS(OS.IOS);
    } else {
      setOS(OS.OTHER);
    }
  }, []);

  return os;
}
